import { render, staticRenderFns } from "./MessageStatusNoteForm.vue?vue&type=template&id=569cc91c&"
import script from "./MessageStatusNoteForm.vue?vue&type=script&lang=js&"
export * from "./MessageStatusNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports